import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedPlaylistCategory: null,
  isFormOpen: false,
};

const playlistCategorySlice = createSlice({
  name: "playlistCategories",
  initialState,
  reducers: {
    setSelectedPlaylistCategory: (state, action) => {
      state.selectedPlaylistCategory = action.payload;
    },
    clearSelectedPlaylistCategory: (state) => {
      state.selectedPlaylistCategory = null;
    },
    togglePlaylistCategoryForm: (state) => {
      state.isFormOpen = !state.isFormOpen;
    },
  },
});

export const {
  setSelectedPlaylistCategory,
  clearSelectedPlaylistCategory,
  togglePlaylistCategoryForm,
} = playlistCategorySlice.actions;

export default playlistCategorySlice.reducer;
